import { BasePage } from '@/components/ui/base-page'

export function InsuranceAndBenefitsNetworkPage() {
  return (
    <BasePage
      title="Insurance & Benefits"
      description="Industry-specific insurance and benefits solutions"
    >
      {/* Add InsurancePage specific content here */}
    </BasePage>
  )
} 